import React from 'react'
import { Link, useNavigate } from 'react-router-dom';

function ResetPasswordDashboard() {
  const navigate = useNavigate();
  const processEmailPasswordReset = () => {
    navigate('/dashboard');
  }

  return (
    <div className='body-page flex-center'>
      <div className="card login-card">
        <h1 className='header-med'>Reset Your Password?</h1>
        <div className="welcome-banner-section width-full margin-top-small margin-bottom-small">
          <label htmlFor="password" className='text-light'>Old Password</label>
          <input type="password" name='password' className='underline-input width-full margin-bottom-small' />
          <label htmlFor="password" className='text-light'>New Password</label>
          <input type="password" name='password' className='underline-input width-full margin-bottom-small' />
          <label htmlFor="password" className='text-light'>Confirm Password</label>
          <input type="password" name='password' className='underline-input width-full margin-bottom-small' />
        </div>
        <button className='btn btn-primary btn-3q-width font-bold' onClick={processEmailPasswordReset}>Reset Password</button>
      </div>
    </div>
  )
}

export default ResetPasswordDashboard